import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ScrollIntoView]',
  standalone: false
})
export class ScrollIntoViewDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('click')
  scrollIntoView() {
    this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
}
